module.exports = __webpack_public_path__ + "img/icon-clock.b8c13b94.svg";